import React from 'react';
import { LeafIcon, MenuIcon, SearchIcon } from 'lucide-react';
export function SiteHeader() {
  return <header className="sticky top-0 z-30 border-b border-neutral-200 bg-white/95 backdrop-blur" data-id="element-189" data-mp="19wb38qcapv54">
      <div className="mx-auto flex h-16 max-w-6xl items-center gap-4 px-4 sm:px-6" data-id="element-190" data-mp="1nn671o7xtm1u">
        <a href="#top" className="flex items-center gap-2.5" aria-label="Nutri Natural Info — inicio" data-id="element-191" data-mp="1inbelg8ikoeo">
          <span className="flex h-9 w-9 items-center justify-center rounded-sm bg-brand text-white" data-id="element-192" data-mp="uxphqzfm6l9u">
            <LeafIcon className="h-5 w-5" aria-hidden="true" data-id="element-193" data-mp="qx5nc3mfdvre" />
          </span>
          <span className="leading-none" data-id="element-194" data-mp="14wexalk1ftmx">
            <span className="block font-serif text-[1.35rem] font-bold tracking-tight text-ink" data-id="element-195" data-mp="14x7zd981xuyq">
              Nutri<span className="text-brand" data-id="element-196" data-mp="zwkbuxj17w99">Natural</span> Info
            </span>
            <span className="mt-0.5 block font-sans text-[0.6rem] font-semibold uppercase tracking-[0.22em] text-ink-muted" data-id="element-197" data-mp="2gasjzn32231d">
              Salud · Metabolismo · Bienestar
            </span>
          </span>
        </a>

        <nav aria-label="Secciones" className="ml-auto hidden items-center gap-6 lg:flex" data-id="element-198" data-mp="29j0pbjib3kzj">
          {['Nutrición', 'Hormonas', 'Fitness', 'Recetas', 'Investigación'].map(item => <a key={item} href="#top" className="font-sans text-[0.8rem] font-medium text-ink-soft transition-colors duration-150 ease-out hover:text-brand" data-id="element-199" data-mp="2jj1bdd7k8f7f">
              {item}
            </a>)}
        </nav>

        <div className="ml-auto flex items-center gap-1 lg:ml-0" data-id="element-200" data-mp="1vrvwp1dcvsyp">
          <button type="button" className="flex h-9 w-9 items-center justify-center rounded-sm text-ink-soft transition-colors duration-150 ease-out hover:bg-neutral-100 hover:text-ink" aria-label="Buscar" data-id="element-201" data-mp="1vqayn1ru1rw3">
            <SearchIcon className="h-4 w-4" aria-hidden="true" data-id="element-202" data-mp="181rv0zjqa3ac" />
          </button>
          <button type="button" className="flex h-9 w-9 items-center justify-center rounded-sm text-ink-soft transition-colors duration-150 ease-out hover:bg-neutral-100 hover:text-ink lg:hidden" aria-label="Abrir menú" data-id="element-203" data-mp="1d1e9tdf7frl9">
            <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-204" data-mp="100ang2fyujz9" />
          </button>
        </div>
      </div>
    </header>;
}